/*
A "calculation" is a "template" with some more fields


{
  template: 'Economic Analysis",
  fit: 0 // Calculation's FIT,
  country: 'United States',
  categories: [
    {
      category: "General view",
      relevance: 5,
      result: 0, // sum of topics result
      fit: 0, // result*relevance/(max possible points)
      order: 1
      topics: [
        { relevance: 5, topic: "Region", information: "--", score: 0, result: 0 order: 1 }
      ]
    }
  ]
}
*/


// const maxRelevance=5;
const maxScore=10;
// const maxPoints=maxScore*maxRelevance;

const fields=[
  'templateId',
  'template',
  'categories',
  'country',
  'fit',
  '_id',
  'defaultApiData' // vide services/countryData - getDefaultCountryData (array)
]


const validate2Save=function() {
  const errorsIds=[];
  return errorsIds;
  // const {categories}=this;
  // categories.forEach(elem=>{
  //   const {topics}=elem;
  //   const catId=elem._id;

  //   topics.forEach(elem=>{
  //     const {score=0,_id}=elem;
  //     if(!score) {
  //       errorsIds.push([catId,_id]);
  //     }
  //   });
  // });

  // return errorsIds;

}


const final=function(data={}) {

  const ret=fields.reduce((accum, curr)=>{
    accum[curr] = data[curr] ? data[curr] : this[curr] ? this[curr] : ''
    return accum;
  },{});

  if(!ret.categories) {
    ret.categories=[]
  }

  if(!ret.defaultApiData) {
    ret.defaultApiData=[];
  }

  ret.categories=ret.categories.map((elem,index)=>{
    if(!elem.result) elem.result=0;
    if(!elem.topics) elem.topics=[];
    if(!elem.order) elem.order=(index+1);
    elem.topics=elem.topics.map((topic,index)=>{
      const {relevance,score,order}=topic;
      if(relevance === undefined || relevance === null) topic.relevance=0;
      if(score === undefined || score === null) topic.score=0;
      if(!order) topic.order=(index+1);
      return {...topic}
    });

    elem.topics.sort((a,b)=>+a.order > +b.order ? 1 : -1);

    return {...elem}
  });

  ret.categories.sort((a,b)=>+a.order > +b.order ? 1 : -1);

  if(ret.templateId === ret._id) {
    ret._id='';
  }

  return {...ret};
}

const calculation = function() {
  const categories=this.categories;
  // let calcTotalMaxRelevance=0;

  // Max possible points
  let maxTotalPoints=0;

  // current points sum
  let calcTotalPoints=0;
  categories.forEach(category=>{
    // const topicsNum=category.topics.length;
    let maxTopicsRelevance=0;

    const currentPoints=category.topics.reduce((accum, curr)=>{
      const {relevance=0,score=0}=curr;
      maxTopicsRelevance+=relevance;
      curr.result=(relevance*score);
      return accum+curr.result;
    },0);

    calcTotalPoints+=currentPoints;
    // maxTopicsRelevance+=maxTopicsRelevance;

    const catMaxPoints=(maxTopicsRelevance*maxScore);
    maxTotalPoints+=catMaxPoints;

    category.result=currentPoints;
    category.fit=+((currentPoints/catMaxPoints)*100).toFixed(0);
  });

  // calculating categories FIT
  // let totalPercent=0;
  // categories.forEach(category=>{
  //   const {relevance,result}=category;
  //   // console.log(`CATEGORY FIT -- relevance: ${relevance} * ${result}/${calcTotalMaxPoints}`,category.category);
  //   category.fit=((relevance*result/calcTotalMaxPoints)*100);
  //   totalPercent+=category.fit;
  // });

  // compensating/scaling
  // categories.forEach(category=>{
  //   category.fit=((category.fit/totalPercent)*100).toFixed(0);
  // });

  this.fit=((calcTotalPoints/maxTotalPoints)*100).toFixed(0);
}


export default (data={})=>{
  data=final.call({},data);

  data.final=final;
  data.calculation=calculation;
  data.validate2Save=validate2Save;

  return data;
}